import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
import * as actions from '../actions';
import Link from 'react-router/lib/Link';
import { get } from 'Language';

class ChangePassword extends Component {

	state = {
		new_password: '',
		confirm_new_password: ''
	}

	changeValue = (e) => {
        const nextState = {};
        const { name, value } = e.target;
        nextState[name] = value;
        this.setState(nextState);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.isSubmitted) {
            const { isSubmitted } = this.props;
            this.setState({
                new_password: '',
                confirm_new_password: ''
            })
            isSubmitted(false);
        }
    }

    submit = (e) => {
    	e.preventDefault();
   		const { changePassword } = this.props;
   		changePassword(this.state);
    }
	
    render(){

		return (
			<div className="panel-custom-wrapper">
				<div className="panel panel-custom">
					<div className="panel-heading">{ get('PASSWORD_LINK') }</div>
					<form onSubmit={this.submit}>
						<div className="panel-body">
							<div className="row">
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <label>{ get('CHANGE_PASSWORD_NEW_PASS') }</label>
                                        <input
                                            value={this.state.new_password} 
                                            onChange={this.changeValue}
                                            type="password"
                                            name="new_password" 
                                            className="form-control form-custom"/>
                                    </div>
                                </div>
                                <div className="col-xs-12">
                                    <label>{ get('CHANGE_PASSWORD_CONFIRM_PASS') }</label>
                                    <input
                                        value={this.state.confirm_new_password} 
                                        onChange={this.changeValue}
                                        type="password"
                                        name="confirm_new_password" 
                                        className="form-control form-custom"/>
                                </div>
                            </div>
						</div>
						<div className="btn-custom text-right panel-footer">
                            <Link className="btn btn-primary" to="/profile">
                            { get('CHANGE_PASSWORD_CANCEL_BUTTON') }
                            </Link>&nbsp;
                            <button className="btn btn-success">
                                { get('CHANGE_PASSWORD_LINK') }
                            </button>
                        </div>
					</form>
				</div>
			</div>
		)
	}
}

export default connect(
	state => {
		const { isSubmitted } = state.changePassword
        
		return {
            isSubmitted
		}
	},
	actions
)(ChangePassword)


// WEBPACK FOOTER //
// ./src/change-password/containers/ChangePassword.js